import {Box, Typography, lighten} from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

const ChipAndLabel = ({color, children}) => (
  <Box sx={{display: 'flex', alignItems: 'center'}}>
    <Box
      sx={theme => ({
        backgroundColor:
          theme.palette[color]?.light ?? lighten(color[500], 0.5),
        border: 'solid 2px',
        borderColor: theme.palette[color]?.main ?? color[500],
        display: 'inline-block',
        height: '1em',
        width: '1em',
        marginRight: 0.5,
      })}
    />
    <Typography component="span" noWrap variant="subtitle2">
      {children}
    </Typography>
  </Box>
);

ChipAndLabel.propTypes = {
  color: PropTypes.string,
  children: PropTypes.node,
};

export default ChipAndLabel;
